/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 27/7/2021
 * @Example
 */


export const types = {
    W06F0009_GET_CBO_EMPLOYEE: 'W06F0009_GET_CBO_EMPLOYEE',
    W06F0009_GET_CBO_CUSTOMER: 'W06F0009_GET_CBO_CUSTOMER',
    W06F0009_GET_CBO_DELIVERY_METHOD: 'W06F0009_GET_CBO_DELIVERY_METHOD',
    W06F0009_GET_CBO_PORTS: 'W06F0009_GET_CBO_PORTS',
    W06F0009_GET_CBO_PAYMENT_METHOD: 'W06F0009_GET_CBO_PAYMENT_METHOD',
    W06F0009_GET_CBO_BANKS: 'W06F0009_GET_CBO_BANKS',
    W06F0009_GET_MASTER_SUPPLEMENT: 'W06F0009_GET_MASTER_SUPPLEMENT',
    W06F0009_GET_DETAIL_SUPPLEMENT: 'W06F0009_GET_DETAIL_SUPPLEMENT',
    W06F0009_GET_CBO_UNIT: 'W06F0009_GET_CBO_UNIT',
    W06F0009_GET_CBO_MARKING: 'W06F0009_GET_CBO_MARKING',
    W06F0009_GET_CBO_PACKING_METHOD: 'W06F0009_GET_CBO_PACKING_METHOD',
    W06F0009_GET_CBO_PACKING_TYPE: 'W06F0009_GET_CBO_PACKING_TYPE',
    W06F0009_GET_CBO_PAYMENT_TERM: 'W06F0009_GET_CBO_PAYMENT_TERM',
    W06F0009_GET_DECIMAL_QUANTITY: 'W06F0009_GET_DECIMAL_QUANTITY',
    W06F0009_LOAD_FORM_ADD_NEW: 'W06F0009_LOAD_FORM_ADD_NEW',
    W06F0009_LOAD_FORM_EDIT: 'W06F0009_LOAD_FORM_EDIT',
    W06F0009_GET_CBO_TYPE_APPENDIX: 'W06F0009_GET_CBO_TYPE_APPENDIX',
    W06F0009_SUBCONTRACTNO: 'W06F0009_SUBCONTRACTNO',
    W06F0009_CHECK_SUBCONTRACTNO: 'W06F0009_CHECK_SUBCONTRACTNO',
    W06F0009_SAVE: 'W06F0009_SAVE',
    W06F0009_EDIT: 'W06F0009_EDIT',
    W06F0009_GET_DATA_DISPLAY: 'W06F0009_GET_DATA_DISPLAY',
    W06F0009_GET_SUB_CONTRACT_TYPE: 'W06F0009_GET_SUB_CONTRACT_TYPE'

}


export function getCbEmployees(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_EMPLOYEE,
        params,
        cb
    }
}

export function getCbCustomer(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_CUSTOMER,
        params,
        cb
    }
}

export function getCboDeliveryMethod(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_DELIVERY_METHOD,
        params,
        cb
    }
}

export function getCboPorts(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_PORTS,
        params,
        cb
    }
}

export function getCboPaymentMenthod(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_PAYMENT_METHOD,
        params,
        cb
    }
}

export function getCboBanks(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_BANKS,
        params,
        cb
    }
}

export function getMasterSupplement(params, cb) {
    return {
        type: types.W06F0009_GET_MASTER_SUPPLEMENT,
        params,
        cb
    }
}

export function getDetailSupplement(params, cb) {
    return {
        type: types.W06F0009_GET_DETAIL_SUPPLEMENT,
        params,
        cb
    }
}

export function getCboUnit(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_UNIT,
        params,
        cb
    }
}

export function getCboMarking(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_MARKING,
        params,
        cb
    }
}

export function getCboPackingMethod(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_PACKING_METHOD,
        params,
        cb
    }
}

export function getCboPackingType(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_PACKING_TYPE,
        params,
        cb
    }
}

export function getCboPaymentTerm(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_PAYMENT_TERM,
        params,
        cb
    }
}

export function getDecimalQuantity(params, cb) {
    return {
        type: types.W06F0009_GET_DECIMAL_QUANTITY,
        params,
        cb
    }
}

export function loadFormAddNew(params, cb) {
    return {
        type: types.W06F0009_LOAD_FORM_ADD_NEW,
        params,
        cb
    }
}

export function loadFormEdit(params, cb) {
    return {
        type: types.W06F0009_LOAD_FORM_EDIT,
        params,
        cb
    }
}

export function getCboTypeAppendix(params, cb) {
    return {
        type: types.W06F0009_GET_CBO_TYPE_APPENDIX,
        params,
        cb
    }
}

export function subContractNo(params, cb) {
    return {
        type: types.W06F0009_SUBCONTRACTNO,
        params,
        cb
    }
}

export function checkSubContractNo(params, cb) {
    return {
        type: types.W06F0009_CHECK_SUBCONTRACTNO,
        params,
        cb
    }
}

export function onSave(params, cb) {
    return {
        type: types.W06F0009_SAVE,
        params,
        cb
    }
}

export function onEdit(params, cb) {
    return {
        type: types.W06F0009_EDIT,
        params,
        cb
    }
}

export function getDataDisplay(params, cb) {
    return {
        type: types.W06F0009_GET_DATA_DISPLAY,
        params,
        cb
    }
}

export function getCbSubContractType(params, cb) {
    return {
        type: types.W06F0009_GET_SUB_CONTRACT_TYPE,
        params,
        cb
    }
}